import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { deleteSpaceInProjectTemplate } from '../../actions';
import { deleteProjectTemplateSpace } from '../../slices';
const selectSpace = (id)=>({ templates })=>templates.project.data[templates.project.activeId].spaceList[id];
function* deleteSpaceInTemplateSaga(action) {
    try {
        const { payload } = action;
        const space = yield select(selectSpace(payload.space.spaceId));
        yield put(deleteProjectTemplateSpace(space));
    } catch (error) {
        logger.error('deleteProjectTemplateSpace failed', {
            error
        });
        message.error('There was an error deleting the space from the template');
    }
}
export function* watchDeleteSpaceInProjectTemplateSaga() {
    yield takeLatest(deleteSpaceInProjectTemplate.type, deleteSpaceInTemplateSaga);
}
